<template>
  <main class="site-content" :class="{ 'site-content--tabs': $route.meta.isTab }">
    <!-- 主入口标签页 s -->
    <el-tabs
      v-if="$route.meta.isTab"
      v-model="mainTabsActiveName"
      :closable="true"
      :tab-position="tabPosition"
      @tab-click="selectedTabHandle"
      @tab-remove="removeTabHandle">
      <el-dropdown class="site-tabs__tools" :show-timeout="0">
        <i class="el-icon-arrow-down el-icon--right"></i>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item @click.native="tabsCloseCurrentHandle">关闭当前标签页</el-dropdown-item>
          <el-dropdown-item @click.native="tabsCloseOtherHandle">关闭其它标签页</el-dropdown-item>
          <el-dropdown-item @click.native="tabsCloseAllHandle">关闭全部标签页</el-dropdown-item>
          <el-dropdown-item @click.native="tabsRefreshCurrentHandle">刷新当前标签页</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <el-tab-pane
        v-for="(item, index) in mainTabs"
        :key="index"
        :label="item.title"
        :name="item.name">
        <div :style="siteContentViewHeight" class="main-content-wraper">
          <iframe
            v-if="item.type === 'iframe'"
            :src="item.iframeUrl"
            width="100%" height="100%" frameborder="0" scrolling="yes">
          </iframe>
          <keep-alive v-else>
            <router-view :mainContentViewHeight="siteContentViewHeight" v-if="item.name === mainTabsActiveName"/>
          </keep-alive>
        </div>
      </el-tab-pane>
    </el-tabs>
    <!-- 主入口标签页 e -->
    <div v-else :style="siteContentViewHeight" class="main-content-wraper">
      <keep-alive>
        <router-view/>
      </keep-alive>
    </div>
  </main>
</template>

<script>
  import {isURL} from '@/utils/validate'
  import {
    goToTab,
    removeTabHandle,
    selectedTabHandle,
    tabsCloseAllHandle,
    tabsCloseCurrentHandle,
    tabsCloseOtherHandle,
    tabsRefreshCurrentHandle
  } from '@/utils/routeTab'

  export default {
    data() {
      return {
        tabPosition: 'top'
      }
    },
    computed: {
      sidebarFold: {
        get () {
          return this.$store.state.common.sidebarFold
        }
      },
      documentClientHeight: {
        get() {
          return this.$store.state.common.documentClientHeight
        }
      },
      menuActiveName: {
        get() {
          return this.$store.state.common.menuActiveName
        },
        set(val) {
          this.$store.commit('common/updateMenuActiveName', val)
        }
      },
      mainTabs: {
        get() {
          return this.$store.state.common.mainTabs
        },
        set(val) {
          this.$store.commit('common/updateMainTabs', val)
        }
      },
      mainTabsActiveName: {
        get() {
          return this.$store.state.common.mainTabsActiveName
        },
        set(val) {
          this.$store.commit('common/updateMainTabsActiveName', val)
        }
      },
      siteContentViewHeight() {
         var height = this.documentClientHeight - 60 - 30 - 2 - 16
        if (this.$route.meta.isTab) {
      //  height -= 40
      height -= 25
           return isURL(this.$route.meta.iframeUrl) ? {height: height + 'px'} : {minHeight: height + 'px'}
           }
        return {minHeight: height + 'px'}
      }
    },
    mounted(){
      this.$nextTick(() => {
        this.iframeInsert(this.$el);
      });
    },
    methods: {
      // tabs, 选中tab
      selectedTabHandle(tab) {
       return selectedTabHandle(tab)
      },
      goToTab(tabItem,fn) {
       goToTab(tabItem,fn)
      },
      // tabs, 删除tab
      removeTabHandle(tabName) {
        removeTabHandle(tabName)
      },
      // tabs, 关闭当前
      tabsCloseCurrentHandle() {
        tabsCloseCurrentHandle()
      },
      // tabs, 关闭其它
      tabsCloseOtherHandle() {
        tabsCloseOtherHandle()
      },
      // tabs, 关闭全部
      tabsCloseAllHandle() {
        tabsCloseAllHandle()
      },
      // tabs, 刷新当前
      tabsRefreshCurrentHandle() {
        tabsRefreshCurrentHandle()
      }
    }
  }
</script>
<style lang="less">

  .site-content > .main-content-wrape{
    height: 105vh;
  }

</style>
